import styled from "styled-components";

import { buttonStyle } from "../styles/global";
import Icons from "../styles/icons";
import {
  textLineHeight,
  videoPreviewBackgroundColor,
  videoPreviewGradientFrom,
  videoPreviewGradientTo,
  videoPreviewTitleColor,
  videoPreviewTitleFontSize
} from "../styles/variables";

export const localizedLogo = (language = "fin"): string =>
  language === "swe" ? Icons.logoArenanSvg : Icons.logoAreenaSvg;

export const Overlay = styled.div<{
  isVisible: boolean;
}>`
  /* stylelint-disable indentation */
  background-color: ${props =>
    props.isVisible ? videoPreviewBackgroundColor : "initial"};
  background-image:
    linear-gradient(
      to bottom,
      ${videoPreviewGradientFrom},
      ${videoPreviewGradientTo} 38px
    ),
    linear-gradient(
      to top,
      ${videoPreviewGradientFrom} 0%,
      ${videoPreviewGradientTo} 76px
    );
  /* stylelint-enable */
  display: flex;
  flex-direction: column;
  inset: 0;
  pointer-events: none; /* ensure that overlay bypasses play-button clicks */
  position: absolute;
  z-index: ${props => (props.isVisible ? "9999999999" : "initial")};
`;

export const OverlayTop = styled.div`
  color: ${videoPreviewTitleColor};
  display: flex;
  font-size: ${videoPreviewTitleFontSize};
  justify-content: space-between;
  line-height: ${textLineHeight};
  margin: 10px 10px 14px;
`;

const OverlayLinkWithIcon = styled.a`
  ${buttonStyle}
  position: relative;
`;

export const OverlayLogo = styled(OverlayLinkWithIcon)<{
  localizedLogo: string;
}>`
  background: url(${props => `"${props.localizedLogo}"`}) center center / 100%
    no-repeat;
  bottom: 0;
  height: 40px;
  left: 10px;
  margin-top: auto;
  width: 100px;
`;
